


















































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
import { Getter } from "vuex-class";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import SolutionInfoModal from "@/components/solutions/modals/SolutionInfoModal.vue";
import SolutionDeleteModal from "@/components/solutions/modals/SolutionDeleteModal.vue";
import SolutionPreviewModal from "@/components/solutions/modals/SolutionPreviewModal.vue";
import ForceOnModal from "@/components/solutions/modals/ForceOnModal.vue";
import SolutionsTileView from "./SolutionsTileView.vue";
import SolutionCopyModal from "@/components/solutions/modals/SolutionCopyModal.vue";

// service methods
import { getFilteredSolutions, getSolutionTypes, GetSolutionStatus } from "@/services/solutions/solutionService";
import { getAllTemplates } from "@/services/templates/templateService";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
// types
import { Solution, SolutionsFilterDtoIn, SolutionTypeEnum } from "@/services/solutions/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { solutionFields, solutionFieldsEditor } from "@/components/solutions/fields/solutionFields";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import i18n from "@/i18n";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree,
        "board-info-modal": SolutionInfoModal,
        "solution-delete-modal": SolutionDeleteModal,
        "board-preview-modal": SolutionPreviewModal,
        "solutions-tile-view": SolutionsTileView,
        "solution-copy-modal": SolutionCopyModal,
        ForceOnModal
    }
})
export default class Solutions extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    // local state
    solutions = [] as Array<Solution>;
    isBusy = false;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    i18n = i18n;
    getSolutionStatus = GetSolutionStatus;
    sortBy = "name";
    sortDesc = false;
    displayView = "List";
    componentsAutoSettingKey = "solutions-display-view-setting";

    // folders
    folderEntity = FolderEntites.Solutions;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;
    folderTreeAutoSettingKey = "solutions-show-folder-tree";

    // filter
    selectedTemplate = null as Option | any;
    filterWidth = "" as string;
    filterHeight = "" as string;
    selectedType = null as string | null;
    selectedStatusOption = null as Option | any;

    // filter options
    templates = [] as Array<Option>;
    searchText = "" as string;
    solutionTypeEnum = SolutionTypeEnum;
    solutionTypes = [] as string[];
    statusOptions = [{ id: "online", text: i18n.t("common.online") }, { id: "offline", text: i18n.t("common.offline") }] as Array<Option>;

    // lifecycle hooks
    public mounted(): void {
        this.displayView = getSetting(this.componentsAutoSettingKey) || "List";
    }

    public created(): void {
        this.initFolderState();
        this.fetchData();
        if (this.isAdmin) {
            bus.$on("reload", () => {
                this.fetchData();
            });
        }
    }

    beforeDestroy() {
        if (this.isAdmin) {
            bus.$off("reload");
        }
    }

    // methods & actions
    initFolderState() {
        this.showFolderTree = getSetting(this.folderTreeAutoSettingKey);
        if (typeof this.showFolderTree === "undefined") {
            // default status for folder tree is open for admin, closed for editors
            this.showFolderTree = this.isAdmin;
        }
    }

    setDisplayView(displayView: string) {
        this.displayView = displayView;
        setSetting(this.componentsAutoSettingKey, this.displayView);
    }

    orderMultipleScreenshot() {
        (this.$refs.solutionsTileView as any).orderMultipleScreenshot();
    }

    setSolutionFolderId(data: { entityId: string, folderId: string }) {
        this.solutions.forEach((solution) => {
            if (solution.id === data.entityId) solution.folderId = data.folderId;
        });
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
            setSetting(this.folderTreeAutoSettingKey, this.showFolderTree);
        }
    }

    deleteSolution(solutionId: string, name: string) {
        (this.$refs.boardDeleteModal as any).open(solutionId, name);
    }

    solutionInfo(solutionId: string) {
        (this.$refs.boardInfoModal as any).open(solutionId);
    }

    updateSolutionSettingsRoute(solutionId: string) {
        return {
            name: "updateSolution",
            params: { solutionId: solutionId }
        };
    }

    previewSolution(solution: Solution) {
        (this.$refs.boardPreviewModal as any).open(solution.id, solution.timeZoneId, solution.width, solution.height, solution.name);
    }

    fetchData() {
        this.loadSolutions();
        getAllTemplates().then(response => {
            this.templates = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });

        getSolutionTypes().then(response => {
            this.solutionTypes = response;
        });
    }

    loadSolutions() {
        this.isBusy = true;
        getFilteredSolutions({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : ""
        } as SolutionsFilterDtoIn).then(response => {
            this.solutions = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedTemplate = null;
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedType = null;
        this.selectedStatusOption = null;
        this.loadSolutions();
    }

    copySolution(solutionId: string) {
        (this.$refs.solutionCopyModal as any).open(solutionId);
    }

    openMassForceOnPrompt() {
        this.$bvModal.show("modal-playerForceOn");
    }

    // computed and watchers
    get model(): Array<Solution> {
        if (this.filterActive) {
            return this.solutions.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width.toString().includes(this.filterWidth)) &&
                    (this.filterHeight === "" ? true : x.height.toString().includes(this.filterHeight)) &&
                    (this.selectedType === null ? true : SolutionTypeEnum[x.type] === this.selectedType) &&
                    (this.selectedStatusOption === null ? true : this.selectedStatusOption.id === "online" ? x.status : !x.status)
            );
        } else {
            return this.showFolderTree && this.selectedFolderNode.id
                ? this.solutions.filter(x => x.folderId === this.selectedFolderNode.id)
                : this.solutions;
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedTemplate && Object.keys(this.selectedTemplate.id).length > 0) ||
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "" ||
            this.selectedType !== null ||
            this.selectedStatusOption !== null);
    }

    get isAdmin() : boolean {
        return this.havePermition(this.getCurrentUser.permissions,
            this.permitionEnum[this.permitionEnum.AdminPrivilege]);
    }

    get fields() {
        if (!this.isAdmin) return solutionFieldsEditor;
        return solutionFields;
    }

    get addSolution() {
        return {
            name: "createSolution",
            params: { folderId: this.selectedFolderNode.id }
        };
    }

    get solutionTypesFormatted() {
        if (this.solutionTypes && this.solutionTypes.length <= 1) {
            return [];
        }

        return Object.keys(this.solutionTypeEnum)
            .filter(x => !(parseInt(x) >= 0) &&
                this.solutionTypes.map(x => x.toLowerCase()).includes(x.toLowerCase()))
            .map(key => ({ name: i18n.t(`solution.${key}`), value: key }));
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        if (value) {
            this.showFolderTree = false;
        } else {
            this.initFolderState();
        }
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
